export default "__VITE_ASSET__DoPJE1AC__"